export enum UserType {
  OWNER = 'owner',
  COLLABORATOR = 'collaborator',
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  EXPIRED = 'expired',
  PAUSED = 'paused',
  PENDING_UPGRADE = 'pending_upgrade',
}

export enum CollaboratorStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum InvitationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}

export enum ClientStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum PlanStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ARCHIVED = 'archived',
}

export enum PlanType {
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  ENTERPRISE = 'ENTERPRISE',
}

export enum ContractStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  EXPIRING_SOON = 'expiring_soon',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  FOR_RENEW = 'for_renew',
  SUSPENDED = 'suspended',
  GRACE_PERIOD = 'grace_period',
  TERMINATED = 'terminated',
}

export enum CancellationReason {
  PRICE_TOO_HIGH = 'PRICE_TOO_HIGH',
  NOT_USING_SERVICE = 'NOT_USING_SERVICE',
  MOVING_LOCATION = 'MOVING_LOCATION',
  FINANCIAL_ISSUES = 'FINANCIAL_ISSUES',
  SERVICE_DISSATISFACTION = 'SERVICE_DISSATISFACTION',
  TEMPORARY_BREAK = 'TEMPORARY_BREAK',
  OTHER = 'OTHER',
}

export enum SuspensionType {
  VACATION = 'vacation',
  MEDICAL = 'medical',
  FINANCIAL = 'financial',
  OTHER = 'other',
}

export enum PaymentFrequency {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  ANNUAL = 'annual',
}

export enum AssetStatus {
  ACTIVE = 'active',
  DELETED = 'deleted',
}

export enum AssetCategory {
  MEDICAL_DOCUMENT = 'medical_document',
  IDENTIFICATION = 'identification',
  INSURANCE = 'insurance',
  CONTRACT_COPY = 'contract_copy',
  OTHER = 'other',
}

export enum ContractAssetType {
  PAYMENT_RECEIPT = 'payment_receipt',
  CONTRACT_DOCUMENT = 'contract_document',
  IDENTIFICATION = 'identification',
  OTHER = 'other',
}

export enum MessageStatus {
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  QUEUED = 'queued',
  SENDING = 'sending',
  SENT = 'sent',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}
